// @flow
import {
  type ContentTypes,
} from '../types';

/* -----------------Utils--------------- */
import {
  isEmpty,
} from 'common/simpleUtils';

const selectModeIconType = {
  close: 'close',
  title: 'title',
  checkall: 'checkall',
  menu: 'menu',
  done: 'done',
};
const standardIconType = {
  back: 'back',
  fav: 'fav',
  unfav: 'unfav',
  info: 'info',
  search: 'search',
  menu: 'menu',
  title: 'title',
  done: 'done',
  normalSearch: 'normalSearch',
  settings: 'settings',
};

const iconFromAction = {
  navigate: 'chevron-right',
  toggle: 'plus',
  menu: 'dots-vertical',
  drag: 'arrow-up-down',
  close: 'close',
};

const selectModeIcons = (
  handleAction: *,
  inReorderingMode?: boolean,
  canSelectAll: boolean,
) => [...inReorderingMode ? [
  {
    name: null,
    type: selectModeIconType.done,
    action: handleAction,
  }] : [...(canSelectAll ? [{
  name: 'check-all',
  type: selectModeIconType.checkall,
  action: handleAction,
}] : []), {
  name: 'dots-vertical',
  type: selectModeIconType.menu,
  action: handleAction,
}]];
const standardIcons = (
  favorited?: boolean,
  contentType?: ?ContentTypes,
  variant?: string,
  handleAction: *,
  showEmptyState?: boolean,
  isAuthenticated?: boolean = true,
  isWhiteLabel?: boolean,
) => {
  const showContentIcons = !isEmpty(contentType) && !isWhiteLabel;
  const showMenu = showContentIcons && variant !== 'smartfolder';
  const showSearch = contentType === 'FOLDER' && !showEmptyState && !isWhiteLabel;

  return [
    ...(favorited && showContentIcons && variant === 'content' && isAuthenticated ? [{
      name: 'heart',
      type: standardIconType.fav,
      action: handleAction,
      tooltip: 'Remove from favorites',
    }] : []),
    ...(!favorited && showContentIcons && variant === 'content' && isAuthenticated ? [{
      name: 'heart-outline',
      type: standardIconType.unfav,
      action: handleAction,
      tooltip: 'Add to favorites',
    }] : []),
    ...(showSearch ? [{
      name: 'folder-search-outline',
      type: standardIconType.search,
      action: handleAction,
      tooltip: 'Search within this content',
    }] : []),
    ...(showContentIcons ? [{
      name: 'information-outline',
      type: standardIconType.info,
      action: handleAction,
      tooltip: 'About this content',
    }] : []),
    ...(showMenu ? [{
      name: 'dots-vertical',
      type: standardIconType.menu,
      action: handleAction,
    }] : []),
    // ...(isWhiteLabel ? [
    // //   {
    // //   name: 'magnify',
    // //   type: standardIconType.normalSearch,
    // //   action: handleAction,
    // //   tooltip: 'About this content',
    // // },
    //   {
    //     name: 'cog-outline',
    //     type: standardIconType.settings,
    //     action: handleAction,
    //   }] : [])
  ];
};
export {
  standardIconType,
  standardIcons,
  selectModeIconType,
  selectModeIcons,
  iconFromAction,
};
